import { createSlice, PayloadAction } from "@reduxjs/toolkit"

import { ICall } from "./../../../types/ads"
import { ICianSubscription, ICurrentUser, ILocation, IUserState } from "./types"


const initialState: IUserState = {
    id: 0,
    name: "",
    username: "",
    group: 0,
    role: 2,
    user_phone_status: 4,
    user_app_status: 1,
    cian_auth_status: 0,
    cian_subscription: null,
    autocall_sources: [],
    user_locations_list: [],
    locationsLoading: false,
    currentCall: null
}

export const currentUserSlice = createSlice({
    name: "currentUser",
    initialState: initialState,
    reducers: {
        currentUserSetData: (state, action: PayloadAction<ICurrentUser>) => {
            state.id = action.payload.id
            state.name = action.payload.name
            state.username = action.payload.username
            state.group = action.payload.group
            state.role = action.payload.role
        },
        currentUserClearData: (state) => {
            state.id = initialState.id
            state.name = initialState.name
            state.username = initialState.username
            state.group = initialState.group
            state.role = initialState.role
        },
        currentUserSetCall: (state, action: PayloadAction<ICall | null>) => {
            state.currentCall = action.payload
        },
        currentUserSetPhoneStatus: (state, action: PayloadAction<2 | 3 | 4>) => {
            state.user_phone_status = action.payload
        },
        currentUserSetAppStatus: (state, action: PayloadAction<1 | 2>) => {
            state.user_app_status = action.payload
        },
        currentUserSetConnectionStatus: (state, action: PayloadAction<{ ws_status: 1 | 2, status: 2 | 3 | 4, cian_auth_status?: 0 | 1, subscription?: ICianSubscription | null, autocall_sources?: number[] }>) => {
            state.user_app_status = action.payload.ws_status
            state.user_phone_status = action.payload.status
            state.cian_auth_status = action.payload.cian_auth_status ?? 0
            state.cian_subscription = action.payload.subscription ?? null
            state.autocall_sources = action.payload.autocall_sources ?? []
        },
        currentUserSetLocationList: (state, action: PayloadAction<ILocation[]>) => {
            state.user_locations_list = action.payload
        },
        currentUserSetLocationsLoading: (state, action: PayloadAction<boolean>) => {
            state.locationsLoading = action.payload
        },
        currentUserSetCianSubscription: (state, action: PayloadAction<ICianSubscription | null>) => {
            state.cian_subscription = action.payload
        },
        currentUserSetAutocallSources: (state, action: PayloadAction<number[]>) => {
            state.autocall_sources = action.payload
        },
    }
})

export const currentUserSliceActions = currentUserSlice.actions
export const currentUserSliceReducer = currentUserSlice.reducer
